import { useState, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import Modal from "../../ReusableComponents/Modal";
import Form from "../../ReusableComponents/Form";
import InputField from "../../ReusableComponents/InputField";
import { nameValidation } from "../../utils/inputValidations";
import InputError from "../../ReusableComponents/InputError";
import { Button } from "../../Components/Helper";
import SelectField from "../../ReusableComponents/SelectField";
import { selectFieldValidation } from "../../utils/inputValidations";
import { postCallingHistory, updateCallingHistory } from "../../apis/BhuMeetTeams/Telecaller/callingHistory";
import TextAreaField from "../../ReusableComponents/TextAreaInput";
import { set } from "lodash";
import { useNavigate } from "react-router";
import { getTelecallerTeams } from "../../apis/adminAPIs/teams";
import { postRequestIssue } from "../../apis/BhuMeetTeams/Oparations/requestIssue";
import Popup from "../../ReusableFunctions/Popup";
import { useSelector } from "react-redux";
import { allIssueTypes } from "../../appConstants";

export const CreateRequestIssue = ({ existingRequest, open, onClose, data, isEdit }) => {

    const userDetails = useSelector(state => state.user?.user)
    const navigate = useNavigate()

    const { currentHeight, currentWidth } = useWindowSize();

    const [RequestIssueForm, setRequestIssue] = useState({
        req_Id: data?.id,
        priority: data?.queueid,
        assignee: data?.reqid,
        type: data?.note || '',
        note: data?.status,
        status: "",
        issue_type: "",
        description: "",
        assigneeID: data?.Data?.assignee

    });

    const [errorIssueNote, setErrorIssueNote] = useState("")
    const [errordescription, setErrordescription] = useState("")

    const [priority, setpriority] = useState([{ label: "Low", value: "Low" }, { label: "Medium", value: "Medium" }, { label: "High", value: "High" }
    ])

    const [IssueType, setIssueType] = useState([])
    const [Assignee, setAssignee] = useState([])

    const [issueSubmitted, setIssueSubmitted] = useState(false);


    useEffect(() => {
        
        
          
          const filteredIssueTypes = allIssueTypes.filter(
            issue => !existingRequest.some(existing => existing.type === issue.value && existing.status == 'open')
        );

        setIssueType(filteredIssueTypes)
        let url = userDetails.bhumeet_role == 'Admin' ? '/bhumeet_team/admin/manage_team/telecallerteam' : userDetails.bhumeet_role == 'Telecaller' ? '/bhumeet_team/telecaller/requestissue/getUsers' : '/bhumeet_team/customerSuccessEngineer/requestissue/getUsers'

        getTelecallerTeams(["Admin", "Customer support engineer"], url).then(res => {
            setAssignee(res.map(x => ({ label: x.name, value: x.id })))
        })
    }, [])



    return (
        <Modal
            header={"Create Issue"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "640px", height: "auto", borderRadius: "10px" }}
        >

            <Form
                onSubmitForm={async (form) => {
                    console.log("subbmit")
                    let formdata = new FormData()
                    if ((errorIssueNote != '' || !RequestIssueForm.note)) {
                        if(errorIssueNote != '' || !RequestIssueForm.note) setErrorIssueNote("Required")
                        return
                    }
                    for (let i in RequestIssueForm) {
                        formdata.append(i, RequestIssueForm[i])
                    }
                    let role = userDetails.bhumeet_role == 'Admin' ? 'operations' : userDetails.bhumeet_role == 'Telecaller' ? 'telecaller' : 'customerSuccessEngineer'
                    setIssueSubmitted(true)
                    postRequestIssue(RequestIssueForm, role).then(res => {
                        setIssueSubmitted(false)
                        Popup.alert("SUCCESS", res, "SUCCESS")
                        onClose()
                        return
                    }).catch(err => {
                        setIssueSubmitted(false)
                        Popup.alert("ERROR", "Something went wrong while creating issue", "ERROR")
                    })
                }}
                initialValues={RequestIssueForm}
            >
                {(onsubmit) => (
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: currentHeight < 695 ? "5px" : "10px",
                        padding: currentHeight < 695 ? "15px 20px" : "20px",
                        alignItems: "center",
                    }}>
                        {/* TextAreaField */}
                        <TextAreaField
                            value={RequestIssueForm.note}
                            name="Note"
                            label={"Note"}
                            onChange={(e) => {
                                console.log(e.target.value)

                                if (e.target.value == '') {
                                    setRequestIssue((prev) => ({ ...prev, note: e.target.value }));
                                    setErrorIssueNote("Required")
                                } else if (e.target.value.length > 200) {
                                    setErrorIssueNote("Character length should be max 200")
                                }else if (e.target.value.length < 200) {
                                    setRequestIssue((prev) => ({ ...prev, note: e.target.value }));
                                    setErrorIssueNote("")
                                }
                                else {
                                    setErrorIssueNote("")
                                }
                            }}
                            placeholder="Enter Your Note"
                            error={errorIssueNote}
                            // height={currentHeight < 850 ? "" : ""}
                            isMandotory={true}
                            hideHeight={true}
                            marginTop="11px"
                            width="100%"

                        />

                        

                        {/* SelectField */}
                        <SelectField
                            handleChange={(selectedOption) => setRequestIssue((prev) => ({ ...prev, priority: selectedOption }))}
                            name="priority"
                            label="Priority"
                            list={priority}
                            styles={{ width: "100%", height: "18px", fontSize: "13px" }}
                            validation={selectFieldValidation}
                            placeholderText="Select Priority"
                            defaultValue={RequestIssueForm.priority}
                            value={RequestIssueForm.priority}
                            containerStyle={{ width: "100%", minHeight: "80px" }}
                        />

                        <SelectField
                            handleChange={(selectedOption) => setRequestIssue((prev) => ({ ...prev, issue_type: selectedOption }))}
                            name="issue_type"
                            label="Issue Type"
                            list={IssueType}
                            isSearchable
                            styles={{ width: "100%", height: "18px", fontSize: "13px" }}
                            validation={selectFieldValidation}
                            placeholderText="Select Issue type"
                            defaultValue={RequestIssueForm.issue_type}
                            value={RequestIssueForm.issue_type}
                            containerStyle={{ width: "100%", minHeight: "80px" }}
                        />


                        <SelectField
                            handleChange={(selectedOption) => {
                                // console.log(selectedOption)
                                setRequestIssue((prev) => ({ ...prev, assignee: selectedOption }))
                            }}
                            name="assignee"
                            label="Assignee"
                            isSearchable
                            className={"Assignee"}
                            list={Assignee}
                            styles={{ width: "100%", height: "18px", fontSize: "13px" }}

                            placeholderText="Select Assignee"
                            value={RequestIssueForm.assignee ? RequestIssueForm.assignee : null}
                            defaultValue={RequestIssueForm.assignee ? RequestIssueForm.assignee : null}
                            containerStyle={{
                                width: "100%",
                                maxWidth: "100%",
                                minHeight: "80px",
                            }}
                            menuPortalTarget={document.getElementById('modalHolder')}
                            validation={selectFieldValidation}
                            controlStyle={{ height: "auto" }}
                        />

                        {/* Buttons (Spanning two columns) */}
                        <div style={{
                            gridColumn: "span 2", // Spanning full width
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            padding: currentHeight < 695 ? "10px" : "20px",
                            height: "70px",
                        }}>
                            <Button isDisabled={issueSubmitted} text="Add" onClick={onsubmit} className="btn-large" />
                            <Button text="Cancel" onClick={onClose} className="btn-large lg-cancel-btn" isBtnNotActive={true} />
                        </div>
                    </div>

                )}
            </Form>


        </Modal>
    )
}